import './main.scss'
import Sprites from '../Sprites/Sprites'
import KowTitle from '../KowTitle/KowTitle'
import { useLocal } from '@/i18n/LocalContext'
import TimeStatus from '../TimeStatus/TimeStatus'
import { useStore } from '@/store'
import Lottery from '../Lottery/Lottery'
import { useEffect, useMemo, useState } from 'react'
import { checkPlayer } from '@/request/utils'
import { clickReport } from '@/report'
import { emitter } from '@/emitter'

export default function Main() {
  const { $t } = useLocal()
  const { state, dispatch } = useStore()
  const [stop, setStop] = useState(false)
  const isCodeBinded = state.login.userInfo.isCodeBinded
  const playerId = state.login.userInfo.playerId
  const playerType = state.login.userInfo.playerType
  const heroWidth = 1384
  const heroHeight = 1089
  const heroSrcList = useMemo(() => {
    const count = 2
    const list = []
    for (let i = 1; i <= 40; i++) {
      const n = count * i - 1
      list.push({
        url: `${process.env.BASE_URL_2}assets/sprites/img_webp/hero${i}_frames.png`,
        frameStart: n - count + 1,
        frameEnd: n,
      })
    }
    return list
  }, [])
  const [renderHero, setRenderHero] = useState(false)
  const [heroReady, setHeroReady] = useState(false)

  useEffect(() => {
    const _handle = () => {
      setRenderHero(true)
    }

    emitter.on('webLoginLoad', _handle)

    return () => {
      emitter.off('webLoginLoad', _handle)
    }
  }, [])

  const openRewardsModal = async () => {
    clickReport('rewardpreview')
    if (!(await checkPlayer('reward'))) return

    dispatch({
      type: 'updateModal',
      data: {
        rewardOpen: true,
      },
    })
  }

  const openRecallModal = async () => {
    clickReport('bind')
    if (!(await checkPlayer('code'))) return

    dispatch({
      type: 'updateModal',
      data: {
        recallOpen: true,
      },
    })
  }

  const openshareModal = async () => {
    clickReport('share2')
    if (!playerId) {
      let res = await checkPlayer('share')
      if (!res) return
    }
    dispatch({
      type: 'updateModal',
      data: {
        shareOpen: true,
      },
    })
  }

  const onLotteryStart = () => {
    setStop(true)
  }

  const onLotteryEnd = () => {
    setStop(false)
  }

  return (
    <div className="main">
      <KowTitle text={$t('回归夺宝')} />
      <TimeStatus />
      <div className="hero-box">
        {renderHero ? (
          <Sprites
            src={heroSrcList}
            corssOrigin={state.canvasCrossOrigin}
            width={heroWidth}
            height={heroHeight}
            frames={80}
            loop={true}
            autoplay={true}
            pause={stop}
            fps={20}
            className="hero"
            onFirstFrame={() => setHeroReady(true)}
          />
        ) : null}
        <img
          src={`${process.env.BASE_URL}assets/img_webp/poster.png`}
          alt=" "
          className="hero"
          style={{ opacity: heroReady ? '0' : '1', position: 'relative' }}
        />
      </div>
      <a className="giftbox btn-active" onClick={openRewardsModal}>
        <span>{$t('奖励预览')}</span>
      </a>
      {playerType === 2 && !isCodeBinded ? (
        <a className="recall-btn btn-active" onClick={openRecallModal}>
          <span>{$t('绑定邀请码')}</span>
        </a>
      ) : null}
      <a className="share-btn btn-active" onClick={openshareModal}>
        <span>{$t('分享邀请码')}</span>
      </a>
      <div className="main-special"></div>
      <Lottery onLotteryStart={onLotteryStart} onLotteryEnd={onLotteryEnd} />
    </div>
  )
}
